export default "__VITE_ASSET__D1e_N_Pg__"